import { render } from "./HelpComponent.vue?vue&type=template&id=53a50078&scoped=true"
import script from "./HelpComponent.vue?vue&type=script&lang=js"
export * from "./HelpComponent.vue?vue&type=script&lang=js"

import "./HelpComponent.vue?vue&type=style&index=0&id=53a50078&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a50078"]])

export default __exports__